import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import {
  selectMechanicBalance,
  selectMechanicDefaultBranchName,
} from "../../../../redux/auth";
import { APP_PATHS } from "../../../../constants/paths";
import WalletNavItem from "./NavItem/WalletNavItem/WalletNavItem";
import PreviousOrdersNavItem from "./NavItem/PreviousOrdersNavItem/PreviousOrdersNavItem";
import MechanicTier from "./MechanicTier/MechanicTier";
import Logout from "./Logout/Logout";
import Price from "../../../Price/Price";
import classes from "./MechanicMenu.module.css";

const MechanicMenu = (props) => {
  const { close } = props;
  const shopName = useSelector(selectMechanicDefaultBranchName);
  const balance = useSelector(selectMechanicBalance);

  const mechanicMenuVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    transition: { duration: 0.3, ease: "easeOut" },
  };

  return (
    <motion.div
      className={classes["mechanic-menu"]}
      variants={mechanicMenuVariants}
      key="mechanic-menu"
      initial="hidden"
      animate="visible"
      exit="hidden"
      transition="transition"
    >
      <div className={classes["mechanic-menu__header"]}>
        <h3 className={classes["mechanic-menu__shop-name"]}>{shopName}</h3>
        <MechanicTier />
      </div>
      <nav>
        <ul className={classes["mechanic-menu__list"]}>
          <li className={classes["mechanic-menu__list-item"]}>
            <Link
              className={classes["mechanic-menu__link"]}
              to={APP_PATHS.WALLET.url}
              onClick={close}
            >
              <WalletNavItem />
              <Price
                value={balance}
                valueClassName={classes["mechanic-menu__balance"]}
              />
            </Link>
          </li>
          <li className={classes["mechanic-menu__list-item"]}>
            <Link
              className={classes["mechanic-menu__link"]}
              to={APP_PATHS.PREVIOUS_ORDERS.url}
              onClick={close}
            >
              <PreviousOrdersNavItem />
            </Link>
          </li>
        </ul>
      </nav>
      <div className={classes["mechanic-menu__logout"]}>
        <Logout />
      </div>
    </motion.div>
  );
};

export default MechanicMenu;

MechanicMenu.propTypes = {
  close: PropTypes.func,
};
